import React, { ReactNode } from 'react'
import { MVPButton } from '../../Buttons/MVPButton'
import './ChoiceModal.scss'

export interface ChoiceModalViewProps
{
	title: string
	text: string | ReactNode
	confirmTitle: string
	cancelTitle: string
	clickChoice: (confirm: boolean) => void
}

export const ChoiceModalView : React.FC<ChoiceModalViewProps> = ({ title, text, confirmTitle, cancelTitle, clickChoice }) =>
{
	return (
		<>
			<span className='modal-title'>{title}</span>
			<span className='modal-subtitle'>{text}</span>
			<div className='buttons'>
				<MVPButton onClick={() => clickChoice(true)}>{confirmTitle}</MVPButton>
				{cancelTitle && <MVPButton onClick={() => clickChoice(false)}>{cancelTitle}</MVPButton>}
			</div>
		</>
	)
}
